const $ = require('cash-dom');
const Ajax = require('./ajax');

let _affiliateLinksData = null;
let _requestMade = false;


function _renderAffiliateLinks(affiliateLinksData) {

  if (affiliateLinksData) {
    var $infoText = $(
      '<p class="affiliate-link-info"><i class="fas fa-exclamation-circle-solid"></i> '
      + affiliateLinksData.info
      + '</p>'
    );

    var $infoA = $(
      '<a class="affiliate_link btn btn-primary btn-square" ' +
      'rel="' + affiliateLinksData.link_rel + '" target="_blank" data-btn-name="Protect button"' +
      'title="' + affiliateLinksData.vendor_title + '" ' +
      'href="' + affiliateLinksData.link_url + '">'
      + '<span class="affiliate-link-text">'
      + affiliateLinksData.link_text
      + '</span>'
      + ' <i class="fas fa-chevron-circle-right"></i>'
      + '</a>'
    );
    var $infoLink = $('<p></p>').append($infoA);

    $('#affiliate-links')
      .append($infoText)
      .append($infoLink);
  }

  if (typeof applyAloomaTracking !== 'undefined') {
    applyAloomaTracking();
  }
}

function _requestForAffiliateLinks() {
  return new Promise((resolve, reject) => {
    const data = {
      action: 'get-affiliate-links',
      pageID: $('body').data('post-id'),
    };

    Ajax.post(ajaxurl, data, function (response) {
      if (response['success']) {
        _requestMade = true;

        var affiliateLinksData = (response['data'])
          ? {
            info: response['data']['info'],
            link_url: response['data']['link_url'],
            link_text: response['data']['link_text'],
            vendor_title: response['data']['vendor_title'],
            link_rel: response['data']['link_rel'],
          }
          : null;

        resolve(affiliateLinksData);
      } else {
        reject(new Error('Can not get affiliate links data.'));
      }

    }, 'json').fail((error) => {
      reject(error);
    });
  });
}

const DetectOS = {
  initAffiliateLinks() {
    return new Promise((resolve, reject) => {
      if (_affiliateLinksData || _requestMade) {
        resolve();
      } else {
        _requestForAffiliateLinks().then((affiliateLinksData) => {
          _affiliateLinksData = affiliateLinksData;
          resolve();
        }).catch((error) => {
          reject(error);
        });
      }
    });
  },

  renderAffiliateLinks() {
    if (_affiliateLinksData) {
      _renderAffiliateLinks(_affiliateLinksData);
    } else {
      this.initAffiliateLinks().then(() => {
        _renderAffiliateLinks(_affiliateLinksData);
      }).catch((error) => {
        console.error(error);
      });
    }
  },
};

module.exports = DetectOS;
